import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Livecoding Recap 47: Webpack build progress indicator for Mac Touchbar",
  "description": "",
  "published": "2017-09-18T00:00:00.000Z",
  "redirect_from": ["/blog/livecoding-recap-47-webpack-build-progress-indicator-mac-touchbar/swizec/7808"],
  "categories": "Livecoding, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`This is a Livecoding Recap – an almost-weekly post about interesting things discovered while livecoding. Usually shorter than 500 words. Often with pictures. Livecoding happens almost `}<strong parentName="em">{`every Sunday at 2pm PDT`}</strong>{` on multiple channels. You should follow `}<a parentName="em" {...{
          "href": "https://www.youtube.com/TheSwizec"
        }}>{`My Youtube`}</a>{` channel to catch me live.`}</em></p>
    <lite-youtube {...{
      "videoid": "cwNlRu5Dy-Y",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`Today, we made history! Webpack progress indicator for the Mac Touchbar! Finally, even web developers can admit that thing is useful 😁`}</p>
    <p>{`Here it is in action on my day job project 👇`}</p>
    <blockquote {...{
      "className": "twitter-tweet",
      "data-dnt": "true"
    }}><p parentName="blockquote" {...{
        "lang": "en",
        "dir": "ltr"
      }}>{`Success. `}<a parentName="p" {...{
          "href": "https://twitter.com/hashtag/webpack?src=hash&ref_src=twsrc%5Etfw"
        }}>{`#webpack`}</a>{` progress indicator on Mac Touchbar`}<br parentName="p"></br><br parentName="p"></br>{`🤘🏼 `}<a parentName="p" {...{
          "href": "https://t.co/8aFSv4iv40"
        }}>{`pic.twitter.com/8aFSv4iv40`}</a></p>{`— Swizec Teller published ServerlessHandbook.dev (@Swizec) `}<a parentName="blockquote" {...{
        "href": "https://twitter.com/Swizec/status/909565004642316288"
      }}>{`September 17, 2017`}</a></blockquote>
    <h2 {...{
      "id": "heres-how-you-set-it-up"
    }}>{`Here's how you set it up`}</h2>
    <p>{`You can start using it right now. All you need is an expensive laptop, my `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/touchbar_webpack_progress"
      }}>{`Touchbar Nyancat Webpack Progress app`}</a>{`, and my fork of `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/nyan-progress-webpack-plugin/tree/send-progress-to-touchbar"
      }}>{`nyan-progress-webpack-plugin`}</a>{`. Both are on Github.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/Swizec/touchbar_webpack_progress"
        }}>{`Download the app`}</a>{`, run it. Set it up to run at startup, if you want to be fancy.`}</li>
      <li parentName="ul">{`Add my nyan-progress-webpack-plugin to your `}<inlineCode parentName="li">{`package.json`}</inlineCode>{`. I'll try to convince @alexkuz to merge it into his published package. When that happens, this step will be easier.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// package.json
"dependencies" {
    // ...
    "nyan-progress-webpack-plugin": "git://github.com/Swizec/nyan-progress-webpack-plugin#send-progress-to-touchbar",
}
`}</code></pre>
    <p>{`Then run installation:`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm install
`}</code></pre>
    <p>{`Now you have my progress indicator. It can talk to your Touchbar when the app from step 1 is running.`}</p>
    <ul>
      <li parentName="ul">{`Update your Webpack config.`}</li>
    </ul>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// webpack.config.js

plugins: [
  // ...
  new require("nyan-progress-webpack-plugin")({
    sendProgressToTouchbar: true,
  }),
];
`}</code></pre>
    <p>{`This enables a Nyan Cat webpack progress indicator in your terminal and tells it to send progress to the touchbar as well. It's behind a feature flag so @alexkuz doesn't get too upset when I make a pull request. Kind of a silly feature :)`}</p>
    <ul>
      <li parentName="ul">{`Voilà! Enjoy your Touchbar Progress indicator.`}</li>
    </ul>
    <h2 {...{
      "id": "heres-how-it-works"
    }}>{`Here's how it works`}</h2>
    <p>{`This joyful hack stands on the shoulders of giants. We used two pieces of open source software and made them work together:`}</p>
    <ol>
      <li parentName="ol">{`Alexkuz's `}<a parentName="li" {...{
          "href": "https://github.com/alexkuz/nyan-progress-webpack-plugin"
        }}>{`nyan-webpack-progress-indicator`}</a>{` provided all the logic to take Webpack's build progress and do something`}</li>
      <li parentName="ol">{`Avatsaev's `}<a parentName="li" {...{
          "href": "https://github.com/avatsaev/touchbar_nyancat"
        }}>{`touchbar nyancat`}</a>{` provided the Touchbar integration because I don't know much about native development.`}</li>
    </ol>
    <p>{`We took those two Nyan Cat… things… and added an HTTP server. That's right. They talk to each other via HTTP because that was the easiest to implement. 😇`}</p>
    <p>{`The native app runs a web server built with `}<a parentName="p" {...{
        "href": "https://github.com/httpswift/swifter"
      }}>{`Swifter`}</a>{`. This part was hard because documentation is scarce and because I've never done Swift code before.`}</p>
    <p>{`We added these lines to what looks like the most important Nyan cat file – `}<inlineCode parentName="p">{`NyanCatCanvas.swift`}</inlineCode>{`.`}</p>
    <pre><code parentName="pre" {...{}}>{`<code class="swift">// NyanCatCanvas.swift

func downloadImage() {
    // stuff that downloads nyan gif

    server["/progress/:progress"] = updateProgress()
    do {
        try server.start(12345)
    } catch {
        print(error)
    }
}

func updateProgress() -> ((HttpRequest) -> HttpResponse) {
    return { r in
    let progress : NSNumber? = NumberFormatter().number(from: r.params.first!.value)

    if progress != nil {
        self.xPosition = -680 + 6.8 * CGFloat(progress!)

        return .ok(.html("Progress: \\(self.xPosition)"))
    }else{
        return .ok(.html("No progress"))
    }
    }
}
`}</code></pre>
    <p>{`We start the server listening on port `}<inlineCode parentName="p">{`12345`}</inlineCode>{` with `}<inlineCode parentName="p">{`server.start(12345)`}</inlineCode>{` and add a route for `}<inlineCode parentName="p">{`/progress/:progress`}</inlineCode>{`. We're listening to GET request on `}<inlineCode parentName="p">{`localhost:12345/progress/<number>`}</inlineCode>{`. Those call `}<inlineCode parentName="p">{`updateProgress()`}</inlineCode>{`.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`updateProgress`}</inlineCode>{` function does a lot of confusing work to convert a maybe string into a computable number. Then it updates `}<inlineCode parentName="p">{`self.xPosition`}</inlineCode>{` with the new position based on progress percentage.`}</p>
    <p>{`Updating `}<inlineCode parentName="p">{`xPosition`}</inlineCode>{` automatically triggers a redraw… somehow. `}<em parentName="p">{`shrug`}</em></p>
    <p>{`That's all the machinery we need to update our Touchbar from anywhere. Next step is to add an HTTP call to the Webpack progress plugin.`}</p>
    <p>{`Like this 👇`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// index.js
function onProgress(...) {
    // ...
  if (options.sendProgressToTouchbar) {
      sendProgressToTouchbar(progress, options);
  }

    // ...
}

function sendProgressToTouchbar(progress, options) {
    var http = require('http');
    var req = http.request({
        port: options.touchbarPort,
        hostname: '127.0.0.1',
        method: 'GET',
        path: '/progress/'+Math.round(progress*100)
    });
    req.end();

}
`}</code></pre>
    <p><inlineCode parentName="p">{`nyan-progress-webpack-plugin`}</inlineCode>{` already has a function hooked into `}<inlineCode parentName="p">{`onProgress`}</inlineCode>{` updates from Webpack's machinery. We added an HTTP call to our Touchbar app via `}<inlineCode parentName="p">{`sendProgressToTouchbar`}</inlineCode>{`.`}</p>
    <p><inlineCode parentName="p">{`sendProgressToTouchbar`}</inlineCode>{` uses node's built-in HTTP client to make a GET request and update the touchbar. There is no error handling because we're lazy and don't care enough.`}</p>
    <p>{`That's all the code it took. Thank you, open source community, for making hacks like this easy to build 😁`}</p>
    <h2 {...{
      "id": "heres-why-this-is-impractical"
    }}>{`Here's why this is impractical`}</h2>
    <p>{`Apple has decided that the Touchbar should only be controlled by the application that's currently in focus. That means you can only use your Touchbar to see Webpack progress when you're actively focusing on `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/touchbar_webpack_progress"
      }}>{`touchbar_webpack_progress`}</a>{`.`}</p>
    <p>{`This makes it useless. ☹️`}</p>
    <p>{`Here's where I hope the open source community will step in. Take your favorite editor and add this as a plugin. If your editor is running this sort of code, it can show Webpack progress while you continue to write code.`}</p>
    <p>{`This is the recipe I envision:`}</p>
    <ol>
      <li parentName="ol">{`Be an editor, use Touchbar integration maybe (iA Writer has formatting, Emacs ignores my Touchbar)`}</li>
      <li parentName="ol">{`Start server, listen on `}<inlineCode parentName="li">{`12345`}</inlineCode></li>
      <li parentName="ol">{`When progress request comes, switch Touchbar to the progress indicator`}</li>
      <li parentName="ol">{`Keep updating until 100%`}</li>
      <li parentName="ol">{`Switch back to normal Touchbar functionality`}</li>
    </ol>
    <p>{`Can you help make that? Please make it.`}</p>
    <p>{`Here's all the code: `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/touchbar_webpack_progress"
      }}>{`the macOS app`}</a>{` and `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/nyan-progress-webpack-plugin/tree/send-progress-to-touchbar"
      }}>{`the Webpack plugin`}</a></p>
    <p>{`🤘`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      